import React, { useEffect } from "react";
import URI from "urijs";
import CustomCardBase from "./CustomCardBase";
import general from "../../../../../../general";
import { NavLink } from "../../../../../../lib/Navigation";
import useActiveState from "../../../../../../lib/useActiveState";

export default function HolidaysMessage({ msg }) {
  const { attach } = msg;
  const [agent] = useActiveState("agent");

  useEffect(() => {
    console.log("HolidaysMessage", attach);
  }, [attach]);
  return (
    <NavLink
      to={(() => {
        let url = URI(attach?.url || "")
          .addQuery("username", localStorage.getItem("username"))
          .addQuery("token", localStorage.getItem("token"))
          .addQuery("location_url", window.location.origin)
          .addQuery("origin", "react")
          .addQuery("agent", agent)
          .addQuery("from", "react")
          .toString();
        return url;
      })()}
      iframe={{ title: attach?.title }}
      user={true}
    >
      <div className="imc-card">
        <div className="imc-card-head">
          <span className="imc-card-tag" style={{ backgroundColor: "#6167E0" }}>
            {"活动"}
          </span>
          <span className="imc-card-tag-title" style={{ color: "#6167E0" }}>
            {attach?.title}
          </span>
        </div>
        <div className="imc-card-body">
          <div className="imc-card-content">
            {attach?.description && (
              <div
                style={{
                  display: "-webkit-box",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: 2,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  color: "#666",
                  whiteSpace: "pre-line",
                }}
                className={`imc-card-desc`.trim()}
              >
                {attach?.description}
              </div>
            )}
            <div style={{ fontSize: 12, color: "#999", paddingTop: 3 }}>
              活动时间: {attach?.time}
            </div>
          </div>
          <img height={63} src={attach?.img_url} alt="" className="imc-card-thumb" />
        </div>
      </div>
    </NavLink>
  );
}
